// extracted by mini-css-extract-plugin
export var boldText = "_7c-4";
export var checkboxContainer = "_7c-6";
export var closeIcon = "_7c-i";
export var container = "_7c-0";
export var drawer = "_7c-8";
export var drawerContent = "_7c-9";
export var extraSmallText = "_7c-5";
export var fulfillmentGroupTable = "_7c-e";
export var largeText = "_7c-3";
export var loadingSpinnerContainer = "_7c-j";
export var mediumText = "_7c-2";
export var narrow = "_7c-f";
export var notificationLink = "_7c-l";
export var packageCheckIconContainer = "_7c-7";
export var slideoutHeaderActions = "_7c-g";
export var slideoutHeaderActionsShifted = "_7c-h";
export var slideoutHeaderContainer = "_7c-a";
export var slideoutModal = "_7c-c";
export var stickyHeaderWrapper = "_7c-b";
export var table = "_7c-k";
export var tableContainer = "_7c-d";
export var tertiaryText = "_7c-1";